import { AgmCoreModule } from '@agm/core';
import type { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';
import type { GoogleMapsConfig } from './google-maps.interface';
import { MapDirectionsDirective } from './map-directions.directive';

@NgModule({
  declarations: [MapDirectionsDirective],
  exports: [AgmCoreModule, MapDirectionsDirective],
})
export class GoogleMapsModule {
  static forRoot(
    mapsConfig: GoogleMapsConfig,
  ): ModuleWithProviders<AgmCoreModule> {
    return AgmCoreModule.forRoot(mapsConfig);
  }
}
